import {
  PassengerRead,
  PayerOrganizationRead,
} from 'src/common/external/bambi-api/bambiApi';

import { TripSubscriptionFormValues } from './FormValues';

export default function validateFormData(
  formData: TripSubscriptionFormValues,
  isTripRequiredFieldsEnabled: boolean,
  selectedPayer?: PayerOrganizationRead | null,
  selectedPassenger?: PassengerRead | null
) {
  const errors: string[] = [];

  if (formData.recurrences.length === 0) {
    errors.push('Please add at least one day of the week.');
  }

  if (selectedPassenger?.deleted_at) {
    errors.push(
      'The selected passenger has been deleted. Please select a different passenger.'
    );
  }

  if (isTripRequiredFieldsEnabled) {
    const passengerErrors = validatePassengerRequiredFields(
      formData,
      selectedPayer
    );
    errors.push(...passengerErrors);
  }

  return errors;
}

const validatePassengerRequiredFields = (
  formData: TripSubscriptionFormValues,
  selectedPayer?: PayerOrganizationRead | null
) => {
  const errors: string[] = [];
  const { weight, phone_number } = formData.passenger;

  const phoneRequired =
    selectedPayer?.trip_required_fields?.passenger_phone_number;

  const weightRequired = selectedPayer?.trip_required_fields?.passenger_weight;

  if (!weight && weightRequired) {
    errors.push(
      'Passenger weight is required. Please click "Edit Selected Passenger" to add a weight.'
    );
  }

  if (!phone_number && phoneRequired) {
    errors.push(
      'Passenger phone number is required. Please click "Edit Selected Passenger" to add a phone number.'
    );
  }

  return errors;
};
